// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-40c9cb86]{padding:8px 16px 0;background-color:#fff}.container .el-col[data-v-40c9cb86]{font-size:14px}.container .imgContainer[data-v-40c9cb86]{display:flex;justify-content:center}", ""]);
// Exports
module.exports = exports;
